/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/* eslint global-require: [0] */

module.exports = {
  router: require('./router'),
  createUser: require('./create-user'),
};
